// extracted by mini-css-extract-plugin
export var deleteModal = "_rq-0";